/**
 * Created by Daniela on 26/09/2016.
 */
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { MaterialListComponent } from "./material/material-list/material-list.component";
import { MaterialDetailComponent } from "./material/material-detail/material-detail.component";
import { MaterialFormComponent } from "./material/material-form/material-form.component";
import { MaterialEspecificacaoComponent } from "./material-especificacao/material-especificacao.component";
import { MaterialEspecificacaoListComponent } from "./material-especificacao/material-especificacao-list/material-especificacao-list.component";
import { MaterialEspecificacaoRegisterComponent } from "./material-especificacao/material-especificacao-register/material-especificacao-register.component";
import { MaterialCodigoBarraListComponent } from "./material-codigo-barra/material-codigo-barra-list/material-codigo-barra-list.component";
import { MaterialCodigoBarraRegisterComponent } from "./material-codigo-barra/material-codigo-barra-register/material-codigo-barra-register.component";
import { newRoute, editRoute, detailRoute } from "../../shared/services/data.service";
import { materialEspecificacaoRouter, materialCodigoBarraRouter, materialRouter } from "./material/shared/data.service";
import { MaterialComponent } from "./material/material.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class MateriaisRoutingModule {}

export const materiaisRoutes: any[] = [
  {
    path: materialRouter,
    component: MaterialComponent,
    children: [
      {
        path: '',
        component: MaterialListComponent
      },
      {
        path: detailRoute + '/:id',
        component: MaterialDetailComponent
      },
      {
        path: newRoute,
        component: MaterialFormComponent
      },
      {
        path: editRoute + '/:id',
        component: MaterialFormComponent
      }
    ]
  },{
    path: materialEspecificacaoRouter,
    component: MaterialEspecificacaoComponent,
    children: [
      {
        path: '',
        component: MaterialEspecificacaoListComponent
      },
      {
        path: newRoute,
        component: MaterialEspecificacaoRegisterComponent
      },
      {
        path: editRoute + '/:id',
        component: MaterialEspecificacaoRegisterComponent
      }
    ]
  },{
    path: materialCodigoBarraRouter,
    component: MaterialEspecificacaoComponent,
    children: [
      {
        path: '',
        component: MaterialCodigoBarraListComponent
      },
      {
        path: newRoute,
        component: MaterialCodigoBarraRegisterComponent
      },
      {
        path: editRoute + '/:id',
        component: MaterialCodigoBarraRegisterComponent
      }
    ]
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/materiais.routing.ts
 **/